<!-- 窜货防伪设置 -->
<template>
    <div class="container">
        <Form :model="formData" label-position="right" :label-width="150">
            <div class="form_title">防窜货设置</div>
            <FormItem label="启用防审货预警：">
                <i-switch v-model="formData.warn_status" size="large" true-color="#FF761D" :true-value="1" :false-value="0">
                    <span slot="open">开启</span>
                    <span slot="close">关闭</span>
                </i-switch>
                <Tooltip max-width="250" placement="right" theme="light">
                    <Icon class="ml-24 cursor-p" type="md-help-circle" size="20" color="#FF761D"/>
                    <div slot="content"><p>配合代理商模块，智能分析匹配并预警。如购买了短信则会短信同步通知</p></div>
                </Tooltip>
            </FormItem>
            <template v-if="formData.warn_status">
                <FormItem label="启用短信通知：">
                    <i-switch v-model="formData.warn_sms" size="large" true-color="#FF761D" :true-value="1" :false-value="0">
                        <span slot="open">开启</span>
                        <span slot="close">关闭</span>
                    </i-switch>
                </FormItem>
                <FormItem label="防审货预警等级：">
                    <Select class="w300" v-model="formData.warn_level" clearable filterable placeholder="请选择等级">
                        <Option v-for="item in warnLevelList" :value="item.id" :key="item.id">{{ item.name }}</Option>
                    </Select>
                    <Tooltip max-width="250" placement="right" theme="light">
                        <Icon class="ml-24 cursor-p" type="md-help-circle" size="20" color="#FF761D"/>
                        <div slot="content"><p>宽松只验证省份，标准验证省+市级，严格验证省+市级+县市</p></div>
                    </Tooltip>
                </FormItem>
            </template>
            <div class="form_title">防伪设置</div>
            <FormItem label="启用防伪预警：">
                <i-switch v-model="formData.preview_status" size="large" true-color="#FF761D" :true-value="1" :false-value="0">
                    <span slot="open">开启</span>
                    <span slot="close">关闭</span>
                </i-switch>
                <Tooltip max-width="250" placement="right" theme="light">
                    <Icon class="ml-24 cursor-p" type="md-help-circle" size="20" color="#FF761D"/>
                    <div slot="content"><p>启用后如果查询超过预警数则开始预警</p></div>
                </Tooltip>
            </FormItem>
            <template v-if="formData.preview_status == 1">
                <FormItem label="启用短信通知：">
                    <i-switch v-model="formData.preview_sms" size="large" true-color="#FF761D" :true-value="1" :false-value="0">
                        <span slot="open">开启</span>
                        <span slot="close">关闭</span>
                    </i-switch>
                </FormItem>
                <FormItem label="防伪预警触发量：">
                    <Input class="w300" type="text" v-model="formData.warn_num" placeholder="请输入防伪预警触发量"></Input>
                    <Tooltip max-width="250" placement="right" theme="light">
                        <Icon class="ml-24 cursor-p" type="md-help-circle" size="20" color="#FF761D"/>
                        <div slot="content"><p>防伪查询次数大于该数时自动触发防伪预警（默认50次）</p></div>
                    </Tooltip>
                </FormItem>
            </template>
            <div class="footer">
                <Button class="theme-bg ml-24" type="warning" @click="submitForm">确定</Button>
            </div>
        </Form>
    </div>
</template>

<script>
import { 
    system_security_index, 
    system_security_save, 
} from '@/api/index';
export default {
    data() {
        return {
            formData: {
                warn_status: 0,
                warn_level: "",
                warn_sms: 0,
                preview_status: 0,
                warn_num: "",
                preview_sms: 0,
            },
            warnLevelList: [
                { id: 1, name: "宽松" },
                { id: 2, name: "标准" },
                { id: 3, name: "严格" },
            ],
        };
    },
    mounted() {
        this.getList();
    },
    methods: {
        getList(){
            system_security_index().then((res) => {
                if(res.data && res.data.length != 0){
                    this.formData.warn_status = res.data.warn_status;
                    this.formData.warn_level = res.data.warn_level;
                    this.formData.warn_sms = res.data.warn_sms;
                    this.formData.preview_status = res.data.preview_status;
                    this.formData.warn_num = res.data.warn_num;
                    this.formData.preview_sms = res.data.preview_sms;
                }
            })
            .catch((err) => {
                this.$Message.error(err.msg);
            });
        },
        // 确定(提交表单)
        submitForm(){
            system_security_save(this.formData).then( res => {
                this.getList();
                this.$Message.success(res.msg);
            }).catch(res=>{
                this.$Message.error(res.msg);
            }) 
        },
    },
};
</script>

<style scoped>
.container {
    padding: 24px;
    background: #ffffff;
    box-shadow: 0px 0px 4px 0px rgba(82, 102, 136, 0.1);
    border-radius: 5px;
    position: relative;
}
.form_title {
    margin-bottom: 24px;
    color: #484E66;
    font-weight: 600;
}
.footer {
    padding: 24px 0 0 0;
    margin: 24px 0 0 0;
    text-align: center;
    border-top: 1px solid #eee;
}
</style>